import { Dashboard } from 'states';

export type DashboardTag = 'live' | 'test';

/** i18n keys for the tag text and its hover hint, per tag. */
export const DASHBOARD_TAG_I18N: Record<DashboardTag, { label: string; hint: string }> = {
  live: { label: 'DASHBOARD_STATUS.LIVE', hint: 'DASHBOARD_STATUS.LIVE_HINT' },
  test: { label: 'DASHBOARD_STATUS.TEST', hint: 'DASHBOARD_STATUS.TEST_HINT' },
};

// A dashboard is LIVE when it is on production and TEST when it is not; the API says which in `status`.
//
// There is deliberately no guessing, from the dashboard's name or from any list kept in this code. Names do not tell:
// production itself has dashboards called "Draft - New In-Service KPIs". Until the API sends `status` (an older
// backend), a dashboard simply gets no tag.

/** The tag to show for a dashboard, or `null` when the API did not say. */
export const getDashboardTag = (dashboard: Pick<Dashboard, 'status'>): DashboardTag | null => {
  if (dashboard.status === 'LIVE') return 'live';
  if (dashboard.status === 'TEST') return 'test';
  return null;
};
